import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "icon icon-warning",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M1.875 20.5 12 3l10.125 17.5H1.875Zm9.375-5.3h1.5v-5h-1.5v5Zm.75 2.6a.779.779 0 0 0 .575-.225A.779.779 0 0 0 12.8 17a.779.779 0 0 0-.225-.575A.779.779 0 0 0 12 16.2a.779.779 0 0 0-.575.225.779.779 0 0 0-.225.575c0 .233.075.425.225.575.15.15.342.225.575.225ZM4.45 19h15.1L12 6 4.45 19Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }